import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Picture {
    constructor(root) {
        this.root = root;
        
        this.init();
    }

    init() {
        this.anim = gsap.fromTo(this.root, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'out',
            scrollTrigger: {
              trigger: this.root,
              start: 'top 90%',
              end: 'bottom 10%',
              invalidateOnRefresh: true,
              // markers: true,
            },
        });
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-picture]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-picture]').forEach(root => {
            const instance = new Picture(root);
            this.instances.push(instance);
        })
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
